
import * as React from 'react';
import PropTypes from 'prop-types';

import {
    Box,
    Breadcrumbs,
    Link,
    Stack,
    Typography,
    styled,
    Grid,
    ButtonGroup,
    Chip,
    Button,
    Menu,
    MenuItem,
    Divider,
    ListItemText,
} from '@mui/material';

import { grey } from '@mui/material/colors';

import PopupState, { bindTrigger, bindMenu } from 'material-ui-popup-state';

import { useNavigate } from 'react-router-dom';

import { CommonIcons, icons } from './CommonIcons';

import { useSystemRoutes } from '../../hooks/useSystemRoutes'

import { useSystemPrompt } from '../../hooks/useSystemPrompt';
import { useTranslations } from "../../hooks/useTranslations";

const StyledBox = styled(Box)(({ theme }) => ({
    marginBottom: theme.spacing(2),
}));

CommonBreadcumbs.propTypes = {
    breadcrumbs: PropTypes.array,
    pageTitle: PropTypes.string,
    pageSubTitle: PropTypes.string,
};

const styles = {
    menuItemText: {
        fontSize: 15,
    }
}

export default function CommonBreadcumbs({
    routeType,
    breadcrumbs,
    pageTitle,
    pageSubTitle,
    LeftComponent = <></>,
    actionMenus
}) {

    const navigate = useNavigate();

    const { t } = useTranslations({ ns: ["common"] })
    const { getRoute } = useSystemRoutes(routeType)
    const { promptMessage } = useSystemPrompt()

    const _defaultLinkProps = {
        color: 'primary.main',
        underline: 'none',
    };

    const linkStyle = {
        fontSize: '0.9rem',
        color: 'primary.main'
    }

    return (
        <StyledBox>
            {/* <Stack
                sx={{

                }}
                flexDirection={"row"}
                justifyContent={"space-between"}
                alignItems={"center"}
            > */}
            <Grid container spacing={0}>
                <Grid item md={6} xs={6} sm={12} display={`flex`} flexDirection={`row`} justifyContent={`flex-start`} alignItems={`center`}>
                    <Box>
                        <Typography variant="h4">
                            {pageTitle}
                        </Typography>
                        <Typography
                            variant="pageSubTitle"
                        >
                            {pageSubTitle}
                        </Typography>
                    </Box>

                    {
                        LeftComponent
                    }

                    {
                        actionMenus && actionMenus.length > 0 && (
                            <PopupState
                                variant="popover"
                                popupId="commonBreadcumbsActionMenu"
                            >
                                {(popupState) => (
                                    <>

                                        <ButtonGroup variant="outline" sx={{ ml: 1 }}>
                                            <Button
                                                {...bindTrigger(popupState)}
                                                size="small"
                                                variant='outlined'
                                                color={'primary'}
                                            // variant="outlined"
                                            // aria-controls={open ? 'split-button-menu' : undefined}
                                            // aria-expanded={open ? 'true' : undefined}
                                            // aria-label="select merge strategy"
                                            // aria-haspopup="menu"
                                            // onClick={handleToggle}
                                            >
                                                {/* <MoreVertIcon /> */}
                                                {/* <CommonIcons name={icons.add} /> */}
                                                <CommonIcons name={icons.chevronDown} />
                                            </Button>
                                        </ButtonGroup>

                                        <Menu
                                            {...bindMenu(popupState)}
                                        >

                                            {
                                                actionMenus.map((item, index) => {

                                                    if (item?.href) {
                                                        return (
                                                            <MenuItem
                                                                key={index}
                                                                sx={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    justifyContent: 'space-between',
                                                                    alignItems: 'center',
                                                                }}
                                                            >
                                                                <Link
                                                                    component="button"
                                                                    underline="none"
                                                                    variant="body2"
                                                                    rel="noopener"
                                                                    // href={item.href}
                                                                    // to={item.href}
                                                                    onClick={() => {
                                                                        navigate(item.href)
                                                                    }}
                                                                    padding={0}
                                                                    color={grey[800]}
                                                                >
                                                                    <ListItemText
                                                                        primary={item?.displayText}
                                                                        // sx={styles.menuItemText}
                                                                        primaryTypographyProps={{
                                                                            sx: styles.menuItemText
                                                                        }}
                                                                    />
                                                                </Link>
                                                                <Link
                                                                    // component="button"
                                                                    underline="hover"
                                                                    variant="body2"
                                                                    rel="noopener"
                                                                    target="_blank"
                                                                    href={item.href}
                                                                    padding={0}
                                                                    color={"primary"}
                                                                >
                                                                    <CommonIcons name={icons.redirect} sx={{ width: 15, height: 15, ml: 1, mt: 0.5 }} />
                                                                </Link>
                                                            </MenuItem>
                                                        )
                                                    }

                                                    return (
                                                        <MenuItem
                                                            key={index}
                                                            // sx={{
                                                            //     m: 1,
                                                            // }}
                                                            onClick={() => {
                                                                popupState.close();

                                                                if (item?.onClick)
                                                                    item.onClick(item);

                                                            }}
                                                            sx={{
                                                                display: 'flex',
                                                                flexDirection: 'row',
                                                                justifyContent: 'space-between',
                                                                alignItems: 'center'
                                                            }}
                                                        >
                                                            <Typography
                                                                color={grey[800]}
                                                                sx={styles.menuItemText}
                                                            >
                                                                {item?.displayText}
                                                            </Typography>
                                                        </MenuItem>
                                                    )
                                                })
                                            }

                                        </Menu>
                                    </>
                                )}
                            </PopupState>
                        )
                    }

                </Grid>
                <Grid item md={6} xs={6} sm={12} textAlign={"right"} display={"flex"} flexDirection={"row"} justifyContent={"flex-end"} alignItems={"center"}>
                    <Box
                        sx={{
                            textAlign: 'right'
                        }}
                    >
                        <Breadcrumbs
                            aria-label="breadcrumb"
                        // separator={<NavigateNextIcon fontSize="small" />}
                        >
                            <Link
                                component="button"
                                key={999}
                                // to={
                                //     getRoute("dashboard")
                                // }
                                onClick={() => {

                                    if (!routeType) {
                                        promptMessage(false, `Invalid route type`)
                                    } else {
                                        navigate(getRoute("dashboard"))
                                    }

                                }}
                                {..._defaultLinkProps}
                                sx={linkStyle}
                            >{t('dashboard')}</Link>

                            {
                                breadcrumbs.map((item, index) => {

                                    const props = { ..._defaultLinkProps, ...item?.props }

                                    // console.log('props', props)


                                    return item?.props?.href ?

                                        (
                                            <Link
                                                component="button"
                                                key={index}
                                                to={item?.props?.href}
                                                onClick={() => {
                                                    // console.info("I'm a button.");
                                                    navigate(item?.props?.href)
                                                }}
                                                {...props}
                                                sx={linkStyle}
                                            >{item?.displayText}</Link>
                                        )
                                        :
                                        (
                                            <Link
                                                component="button"
                                                key={index}
                                                disabled
                                                {...props}
                                                sx={[linkStyle, { color: 'secondary.main' }]}
                                            >{item?.displayText}</Link>
                                        )


                                })
                            }

                        </Breadcrumbs>
                    </Box>
                </Grid>
            </Grid>
            {/* </Stack> */}
        </StyledBox>
    );
}